import { render } from "./PermissionsByCategoryList.vue?vue&type=template&id=3a412f94&scoped=true"
import script from "./PermissionsByCategoryList.vue?vue&type=script&lang=js"
export * from "./PermissionsByCategoryList.vue?vue&type=script&lang=js"

import "./PermissionsByCategoryList.vue?vue&type=style&index=0&id=3a412f94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a412f94"]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItemLabel,QBtn,QItem,QItemSection,QCheckbox,QChip,QTooltip});
